import cn from 'classnames'
import { InputField } from '@components/forms/InputField'
import { SelectButton } from '@features/profile/components/SelectButton'
import { AddressSearchSelectField } from '@components/forms/AddressSearchSelectField'
import { TextAreaField } from '@components/forms/TextAreaField'
import { SelectSearchField } from '@components/forms/SelectSearchField'
import { WriterEnum } from '@interfaces/WriterEnum'
import { ResidenceEnum } from '@interfaces/ResidenceEnum'
import { CertificateAddressProps } from './interface'

export function CertificateAddress({
  values,
  residenceOptions,
  countryOptions,
  handleAddressChange,
}: CertificateAddressProps) {
  return (
    <div>
      <h2 className='font-mitr text-[24px] ladding-[1.5] font-medium text-secondary dark:text-dark-10'>
        ที่อยู่ตามหนังสือรับรอง
      </h2>
      <div className='grid grid-cols-3 tablet:grid-cols-2 mobile:grid-cols-1 gap-[20px] mt-[20px] mobile:mt-[10px]'>
        <SelectButton
          name='residence'
          label='ประเทศ'
          options={residenceOptions}
        />
        {values.residence === ResidenceEnum.LOCAL ? (
          <>
            <InputField
              name='certificateAddress'
              label='ที่อยู่'
              placeholder='รายละเอียดที่อยู่ เช่น บ้านเลขที่, ตึก, อาคาร, ซอย, หมู่ที่'
              showErrorMsg={false}
            />
            <AddressSearchSelectField
              name='certificatePostcode'
              label='รหัสไปรษณีย์'
              addressKey='zipcode'
              placeholder='รหัสไปรษณีย์'
              onChange={handleAddressChange}
            />
            <AddressSearchSelectField
              name='certificateProvince'
              label='จังหวัด'
              addressKey='province'
              placeholder='จังหวัด'
              onChange={handleAddressChange}
            />
            <AddressSearchSelectField
              name='certificateDistrict'
              label='เขต / อำเภอ'
              addressKey='amphoe'
              placeholder='เขต / อำเภอ'
              onChange={handleAddressChange}
            />
            <AddressSearchSelectField
              name='certificateSubDistrict'
              label='แขวง / ตำบล'
              addressKey='district'
              placeholder='แขวง / ตำบล'
              onChange={handleAddressChange}
            />
          </>
        ) : (
          <>
            <SelectSearchField
              name='certificateCountry'
              label='ประเทศ'
              placeholder='เลือกประเทศ'
              options={countryOptions}
            />
            <InputField
              name='aboardCertificatePostcode'
              label='รหัสไปรษณีย์'
              placeholder='รหัสไปรษณีย์'
              showErrorMsg={false}
            />
            <TextAreaField
              className={cn({
                'col-span-2 tablet-mobile:col-span-1':
                  values.type === WriterEnum.INDIVIDUAL,
                'col-span-3 tablet-mobile:col-span-1':
                  values.type === WriterEnum.LEGAL,
              })}
              textAreaClassName='min-h-[120px]'
              name='aboardCertificateAddress'
              label='ที่อยู่'
              placeholder='รายละเอียดที่อยู่ เช่น บ้านเลขที่, ตึก, อาคาร, ซอย, หมู่ที่'
            />
          </>
        )}
      </div>
    </div>
  )
}
